import { render } from "./UploadDocumentCreateShipment.vue?vue&type=template&id=b66c8ea6"
import script from "./UploadDocumentCreateShipment.vue?vue&type=script&lang=js"
export * from "./UploadDocumentCreateShipment.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__